enum ScreeningJourneyTypeEnum {
	TMC = 'TMC',
	MODERATE_DEPRESSION = 'MODERATE_DEPRESSION',
	SEVERE_DEPRESSION = 'SEVERE_DEPRESSION',
	ANXIETY = 'ANXIETY',
	ANXIETY_STEP = 'ANXIETY_STEP',
	EXHAUSTION = 'EXHAUSTION',
	IBC = 'IBC',
	LIFE_QUALITY = 'LIFE_QUALITY',
	TRAUMA = 'TRAUMA',
	NOT_ELIGIBLE_FOR_JOURNEY = 'NOT_ELIGIBLE_FOR_JOURNEY',
	SUBSTANCE_ABUSE = 'SUBSTANCE_ABUSE',
	PREGNANCY = 'PREGNANCY',
}

enum ProfessionalType {
	psychologist = 'psychologist',
	coach = 'coach',
	psychoanalyst = 'psychoanalyst',
	therapist = 'therapist',
	psychiatrist = 'psychiatrist',
	nutritionist = 'nutritionist',
}

export interface GetPromptuaryResponseV2 {
	id?: string;
	serviceEvolutionPsychiatrist?: {
		currentDiseaseHistory?: string | null;
		personalBackground?: string | null;
		familyBackground?: string | null;
		habitsAndVices?: string | null;
		medicationsAndDoses?: string | null;
	};
	complaintAndDuration?: string;
	currentDiseaseHistory?: string;
	psychicExamination?: string;
	clinicalExamination?: string;
	conduct?: string;
	alarmSignals?: boolean;
	alarmSignalsReason?: string;
	icd10?: {
		id: string;
		description: string;
	}[];
	outcome?: string;
	outcomeReason?: string;
	outcomeSpecialty?: string;
	outcomeOtherSpecialty?: string;
	outcomeForwardJourney?: ScreeningJourneyTypeEnum;
	outcomeForwardJourneySessionNumber?: number;
	serviceEvolution?: string;
	sessionReasons?: string[];
	dayOfSession: Date;
	customerName: string;
	isRegistered?: boolean;
	registeredAt?: Date;
	professional?: {
		displayName?: string;
		formattedLicense?: string;
		mainType?: ProfessionalType;
	};
	registeredBy?: string;
}

export enum PromptuaryErrors {
	GET_PROMPTUARY_404_ERROR = 'PROMPTUARY.ERRORS.GET_PROMPTUARY_404_ERROR',
	GET_PROMPTUARY_GENERIC_ERROR = 'PROMPTUARY.ERRORS.DEFAULT_GET_PROMPTUARY_ERRROR',
	GET_APPOINTMENT_ERROR = 'PROMPTUARY.ERRORS.GET_APPOINTMENT_ERROR',
	GET_PROFILE_ERROR = 'PROMPTUARY.ERRORS.GET_PROFILE_ERROR',
	CREATE_PROMPTUARY_ERROR = 'PROMPTUARY.ERRORS.DEFAULT_CREATE_PROMPTUARY_ERROR',
	PROMPTUARY_ALREADY_EXISTS = 'PROMPTUARY.ERRORS.PROMPTUARY_ALREADY_EXISTS',
}
export enum SentryPromptuaryErrorsMessages {
	GET_PROMPTUARY_404_ERROR = 'Promptuary not found',
	GET_PROMPTUARY_GENERIC_ERROR = 'Error getting promptuary',
	GET_APPOINTMENT_ERROR = 'Error getting appointment',
	GET_PROFILE_ERROR = 'Error getting profile',
	CREATE_PROMPTUARY_ERROR = 'Error creating promptuary',
	PROMPTUARY_ALREADY_EXISTS = 'Promptuary already exists',
}

export enum PromptuaryBreadcrumb {
	NOT_FOUND_ERROR = 'promptuary not found',
	PAGE_OPEN = 'promptuary page open',
	PAGE_CLOSE = 'promptuary page close',
	SIDEBAR_OPEN = 'promptuary sidebar open',
	SIDEBAR_CLOSE = 'promptuary sidebar close',
	SIDEBAR_LOADING = 'promptuary sidebar loading',
	SIDEBAR_LOADED = 'promptuary sidebar loaded',
	CREATING_PROMPTUARY = 'creating promptuary',
	PROMPTUARY_CREATED = 'promptuary created',
}
